import { buildHref } from "@softmax/web-addresses";
import notFound from "./not-found.module.css";

export function ProductRouteNotFound() {
  return (
    <main id="main" data-shell-page tabIndex={-1} className={notFound.page}>
      <h1 className={notFound.title}>Page not found</h1>
      <a href={buildHref({ name: "browse" })} className={notFound.link}>
        Browse coworlds
      </a>
    </main>
  );
}
